const forms = () => {
    const passwordFields = document.querySelectorAll('[data-password-input]');
    passwordFields.forEach((field) => {
        const input = field.querySelector('input');
        const toggle = field.querySelector('[data-show-password-toggle]');
        if (input && toggle) {
            toggle.addEventListener('click', () => {
                if (input.type === 'password') {
                    input.type = 'text';
                    toggle.classList.add('password-input__toggle--active');
                }
                else {
                    input.type = 'password';
                    toggle.classList.remove('password-input__toggle--active');
                }
            });
        }
    });
};
export { forms };
